module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Keyboard-Mouse.6139cb44.jpg";